export default {
  pageIntro: "You're applying for a",
  pageSubheading1: "M&S Personal Loan"
};
